import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var hookToFAC = function hookToFAC(hook) {
  var NewComponent = function NewComponent(props) {
    var hookValues = hook(props);
    var children = props.children;
    return ___EmotionJSX(React.Fragment, null, children(hookValues));
  };

  NewComponent.displayName = "hookToFAC(".concat(hook.name, ")");
  return NewComponent;
};